import { render, staticRenderFns } from "./picDetail.vue?vue&type=template&id=b2830812&scoped=true&"
import script from "./picDetail.vue?vue&type=script&lang=js&"
export * from "./picDetail.vue?vue&type=script&lang=js&"
import style0 from "./picDetail.vue?vue&type=style&index=0&id=b2830812&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2830812",
  null
  
)

export default component.exports